import AesGcmCrypto from 'react-native-aes-gcm-crypto';

const encrypt = async (data: string, key: string) => {
  const result = await AesGcmCrypto.encrypt(data, false, key);
  return `${result.iv}${result.tag}${result.content}`;
};

const decrypt = async (cipherTextWithIvAndTag: string, key: string) => {
  let iv = cipherTextWithIvAndTag.substring(0, 24);
  let tag = cipherTextWithIvAndTag.substring(24, 56);
  let content = cipherTextWithIvAndTag.substring(56);
  let decrypted = await AesGcmCrypto.decrypt(content, key, iv, tag, false);
  return decrypted;
};

export default {
  encrypt,
  decrypt,
};
